window.slate = window.slate || {};
window.theme = window.theme || {};

// MAX FREE gifts with purchase
Shopify.quota = '3';
Shopify.amount = '50';

// Shopify qualified discount
var getCookie = function(name) {
  var value = "; " + document.cookie;
  var parts = value.split('; '+name+'=');
  if (parts.length == 2) return parts.pop().split(";").shift();
};
Shopify.codeCookieValue = getCookie('discount_code');

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '$';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
        
        $('#availability').html('<link itemprop="availability" href="http://schema.org/InStock">');
      } else {
        //$(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        $(selectors.addToCartText, this.$container).html('Email me when available');
        $(selectors.addToCartText).parent().attr('id', 'BIS_trigger');
        
        $('#availability').html('<link itemprop="availability" href="http://schema.org/OutOfStock"><hr><p>Unfortunately, this product is currently sold out. Please click on the button below to be contacted as soon as this product is back in stock.</p>');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        
        $('#availability').html('<link itemprop="availability" href="http://schema.org/InStock">');

      } else {
        //$(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html('Email me when available');
        $(selectors.addToCartText).parent().attr('id', 'BIS_trigger');
        
        $('#availability').html('<link itemprop="availability" href="http://schema.org/OutOfStock"><hr><p>Unfortunately, this product is currently sold out. Please click on the button below to be contacted as soon as this product is back in stock.</p>');
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      this.$featuredImage.attr('src', sizedImgUrl);

      var alt = variant.featured_image.alt;
      if (alt != null && alt.indexOf("youtube.com") >= 0) {
        $('.img a').attr('href', alt);
        $('.img .zoom').removeClass('zoom');
      }
      else {
        $('.img a, .featuredimage').addClass('zoom');
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

$( document ).ready(function() {

  /* add / remove fixed nav */
  var body = $("body");
  $(window).scroll(function() {
      var scroll = $(window).scrollTop();
      var val = '';
      if (jQuery(window).width() <= 767) {
        val = 30;
      }
      else {
        val = 34;
      }

      if (scroll > val) {
          body.addClass('scrolled');
      } else {
          body.removeClass('scrolled');
      }
  });

  /* dropdown: hover */
  $('#site-nav .left-nav .desktop')
    .mouseenter(function() {
      $('#site-dropdown-bg')
        .stop(true, false)      
        .fadeIn(500);
    })
    .mouseleave(function() {
      $('#site-dropdown-bg')
        .stop(true, false)
        .fadeOut(500);
    });

  $('#site-nav .left-nav .desktop > li, #site-nav .right-nav .text > li:first-child')
    .mouseenter(function(e) {
      e.preventDefault();
      $(this)
        .addClass('active')
        .find('.site-dropdown')
        .stop(true, false)
        .fadeIn(500);
    })
    .mouseleave(function(e) {
      e.preventDefault();
      $(this).removeClass('active');
      $('.site-dropdown')
        .stop(true, false)
        .fadeOut(500);
    });

  /* dropdown: click */
  $('#site-nav .left-nav .desktop > li > a, #site-nav .right-nav .text > li:first-child > a').click(function(e) { 
    if (jQuery(window).width() <= 1024) {
      e.preventDefault(); 
      $(this).blur();

      var parent = $(this).parent();

      // disable making changes to dropdown if dropdown is animating
      if ($(parent).find('.site-dropdown').is(':animated')) { return false; }

      // hide or show dropdown as appropriate
      if ( $(parent).hasClass('active') ) {
        $(parent).mouseleave();
      }
      else {
        $(parent).mouseenter();
      }
    }
  });

  /* search dropdown: hover */
  $('#site-nav .right-nav li.search')
    .mouseenter(function(e) {
      e.preventDefault();
      $(this)
        .addClass('active')
        .find('.search-dropdown')
        .stop(true, false)
        .fadeIn(500);
    
      $("input[type=search]").focus();
    })
    .mouseleave(function(e) {
      e.preventDefault();
      $(this).removeClass('active');
      $('.search-dropdown')
        .stop(true, false)
        .fadeOut(500);
    });
  
  $('#site-nav .right-nav li.search a')
    .click(function(e) {
      e.preventDefault();
      $(this)
        .addClass('active')
        .find('.search-dropdown')
        .stop(true, false)
        .fadeIn(500);
    
      $("input[type=search]").focus();
    });

  /* search dropdown: click */
  $('#site-nav .right-nav li.search > a').click(function(e) { 
    e.preventDefault(); 
    this.blur();

    // disable making changes to dropdown if dropdown is animating
    if ($(this).find('.search-dropdown').is(':animated')) { return false; }

    // hide or show dropdown as appropriate
    if ( $(this).parent().hasClass('active') ) {
      $(this).parent().mouseleave();
    }
    else {
      $(this).parent().mouseenter();
    }
  });

  /* mobile nav */
  $('#menu-toggle').click(function() {
    $(this).toggleClass('active');
    $('body').toggleClass('mobile-menu-active');
    $('#site-nav-mobile').fadeToggle();
  });

  $('#site-nav-mobile .subnav-toggle').click(function() {
    $(this).toggleClass('active');
    $(this).children('ul').slideToggle();
  });

  $('#site-nav-mobile .subnav-toggle > a').click(function(e) {
    e.preventDefault();
  });



  /*
   * NEWSLETTER SIGNUPS
  */
  $('.section-home-newsletter .button input[name=submit]').click(function() {
    Privy.show(324005);
    // catch email
    var email = $('.section-home-newsletter input.text').val();
    // set timer
    var privyTimer = setInterval(function(){ updateEmail() }, 500);
    function updateEmail() {
       if ($("#privy-submit-btn").html()) {
         $('.privy-email-input').val(email);
         clearTimeout(privyTimer);
      }
    }
  });
  $('.section-page-newsletter .form input[name=submit]').click(function() {
    Privy.show(324005);
    // catch email
    var email = $('.section-page-newsletter input.text').val();
    // set timer
    var privyTimer = setInterval(function(){ updateEmail() }, 500);
    function updateEmail() {
       if ($("#privy-submit-btn").html()) {
         $('.privy-email-input').val(email);
         clearTimeout(privyTimer);
      }
    }
  });


  /*
   * PRODUCTS
  */

  /* mobile product nav: featured collection */
  $('.products-nav .left, .products-nav .right').click(function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');

    if ($(this).hasClass('left')) {
      $(this).closest('.product-grid').find('.product-grid-item:first-child').show();
      $(this).closest('.product-grid').find('.product-grid-item:last-child').hide();
    }
    else {
      $(this).closest('.product-grid').find('.product-grid-item:first-child').hide();
      $(this).closest('.product-grid').find('.product-grid-item:last-child').show();
    }
  });

  /* product quantity */
  $('.product-quantity-box .quantity-minus').click(function() {
    var input = $(this).parent().find('input.quantity');
    var val = parseInt($(input).val()) - 1;
    if (val < 0) { val = 0; }
    $(input).val(val);
    $(input).change();
  });
  $('.product-quantity-box .quantity-plus').click(function() {
    var input = $(this).parent().find('input.quantity');
    var val = parseInt($(input).val()) + 1;
    $(input).val(val);
    $(input).change();
  });



  /*
   * POPUPS
  */
  $('.video-popup').magnificPopup({
    disableOn: 0,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: true
  });
    
});
$( document ).ready(function() {

  function showCart() {
    if (jQuery(window).width() >= 1024 && 
      !jQuery('body#your-shopping-cart').length &&
      $('#site-nav .right-nav li.cart > a .num').text() != '0') {

      $('#site-nav .right-nav li.cart').addClass('active');
      $('#cart-dropdown').show();  
      $('#cart-dropdown .dropdown')
        .stop(true, false)
        .animate({right: 0}, 400);
      $('#cart-dropdown-bg')
        .stop(true, false)
        .fadeIn(500);

    }
  }

  function hideCart() {
    if (jQuery(window).width() >= 1024 && 
      !jQuery('body#your-shopping-cart').length) {

      $('#site-nav .right-nav li.cart').removeClass('active');
      $('#cart-dropdown .dropdown')
        .stop(true, false)
        .animate({right: '-460px'}, 400, function() {
          $('#cart-message').removeClass('error').empty();
          $('#cart-dropdown').hide();
        });
      $('#cart-dropdown-bg')
        .stop(true, false)
        .fadeOut(400);

    }
  }

  function updateCart() {
    // get cart data
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cartdata){
        	// dk script
          var dk_count = 0;
          for(var i = 0; i < cartdata.items.length; i++) {
            if(cartdata.items[i].vendor === "DailyKarma") {
              dk_count+=1;
            }else {
              dk_count+=cartdata.items[i].quantity;
            }
          }
			// dk script end
          // update counts
          $('#site-nav li.cart span.num, #cart-dropdown span.num').html(dk_count); // cartdata.item_count

          // update cart table
          var cart = '<table cellpadding="0" cellspacing="0">';
          for (var i = 0; i < cartdata.items.length; i++) {
              cart += '<tr>';

              // image
              if (cartdata.items[i]['image'] != '') {
                  cart += '<td class="img">';
                  cart += '<a href="' + cartdata.items[i]['url'] + '">';
                  cart += '<img src="' + cartdata.items[i]['image'] + '" alt="' + cartdata.items[i]['title'] + '">';
                  cart += '</a></td>';
              }
              else {
                cart += '<td class="img"></td>';
              }

              // text
              cart += '<td class="product">';
                  cart += '<a class="title" href="' + cartdata.items[i]['url'] + '">' + cartdata.items[i]['product_title'] + '</a>';

                  cart += '<div class="info">';
                  if (cartdata.items[i]['variant_title'] != null) {
                      cart += '<div class="variant">' + cartdata.items[i]['variant_title'] + '</div>';
                  }
            	  if(cartdata.items[i].vendor !== "DailyKarma") {
            	  	  cart += '<div class="quantity">Quantity: ' + cartdata.items[i]['quantity'] + '</div>';
                  }
                  
                  cart += '</div>';

                  cart += '<a class="remove" href="/cart/change?line=' + (i+1) + '&amp;quantity=0">Remove</a>';
              cart += '</td>';

              // pricing
              cart += '<td class="price">' + slate.Currency.formatMoney(cartdata.items[i]['line_price'], theme.moneyFormat) + '</td>';

              cart += '</tr>';
          }
          cart += '</table>';
          $('#site-nav #cart').html(cart);

          // update total
          $('#cart-dropdown #subtotal').html( slate.Currency.formatMoney(cartdata.total_price, theme.moneyFormat) );

          // hide checkout if appropriate
          if (cartdata.item_count == 0) {
            $('#cart-dropdown form .subtotal').hide();
            $('#cart-dropdown form input.b-button-filled').hide();
          }
          else {
            $('#cart-dropdown form .subtotal').show();
            $('#cart-dropdown form input.b-button-filled').show();
          }

          showCart();
      },
      error: function() {
        showCart();
      }
    });
  }

  /* cart dropdown: hover */
  $('#site-nav .right-nav li.cart')
    .mouseenter(function(e) {
      e.preventDefault();
      showCart();
    })
    .mouseleave(function(e) {
      e.preventDefault();
      hideCart();
    });

  /* cart dropdown: remove product from cart */
  $('#cart-dropdown #cart').on('click', 'a.remove', function(e) {
    e.preventDefault();
    e.stopPropagation();

    var link = $(this).attr('href')
    $.post($(this).attr('href'), null, null, "json")
        .fail(function(result) {
          var data = JSON.parse(result.responseText);
          $('#cart-message').addClass('error').html('<span>' + data.description + '</span>');
        })
        .done(function(result) {
          updateCart();
        });
  });
    
  /* cart dropdown: hide if background clicked */
  $('#cart-dropdown').click(function() {
    // hideCart();
  });

  /* cart dropdown: continue shopping */
  $('#cart-dropdown .continue').click(function(e) {
    e.preventDefault();
    hideCart();
  });
  
  /* cart update total price */
  $('body.template-cart input.quantity').change(function() {
    var parent = $(this).parents('tr');
    var quantity = parseInt($(this).val());
    var price = $(parent).find('td.price').data('price');

    // update total for row
    $(parent).find('td.total').data('total', price * quantity);
    $(parent).find('td.total').html( slate.Currency.formatMoney(price * quantity, theme.moneyFormat) );

    // update cart subtotal
    var numproducts = 0;
    var subtotal = 0;
    $('table#cart tr').each(function() {
      var num = $(this).find('input.quantity').val();
      if (num) { numproducts += parseInt(num); }

      var total = $(this).find('td.total').data('total');
      if (total) { subtotal += parseInt(total); }
    });
    $('table#totals td.subtotal').html( slate.Currency.formatMoney(subtotal, theme.moneyFormat) )

    // update product num total
    $('body.template-cart .page-cart header .num').text(numproducts);
  });

  
  // GWP functions
  /* quick add to cart functionality */
  $('.product-grid-item form, .page-product-header form, #gwp').submit(function(e) {
    
    if (jQuery(window).width() >= 1024) {

      e.preventDefault();
      $.post('/cart/add.js', $(this).serialize(), null, "json")
        .fail(function(result) {
          var data = JSON.parse(result.responseText);
          $('#cart-message').addClass('error').html('<span>' + data.description + '</span>');
          showCart();
        })
        .done(function(result) {
          updateCart();
        });
    }
    
  });
  
  const updateQueue = function(e) {
    const variantId = $(this).data('id');
    
    Shopify.queue = Shopify.queue || [];
    
    const vIndex = Shopify.queue.findIndex(p => variantId == p.variantId);
    if (vIndex >= 0) {
      // remove from the cart
      Shopify.removeItem(variantId);
      // remove it from the queue
      Shopify.queue.splice(vIndex, 1);

      $(this).removeClass('selected');
    } else if (1 == Shopify.quota) {
      Shopify.queue.forEach(q => {
        Shopify.removeItem(q.variantId);
        $("[data-id='" + q.variantId + "']").removeClass('selected');
      });
      
      Shopify.queue = [];
      
      Shopify.queue.push({
        variantId: variantId,
        quantity: 1
      });
      $(this).addClass('selected');
    } else if (Shopify.queue.length < Shopify.quota) {
      Shopify.queue.push({
        variantId: variantId,
        quantity: 1
      });
      $(this).addClass('selected');
    }
  };
  
  $('#shoppingbag').click(function(e) {
      $('#shoppingbag span').text('Please wait...');
      $('#shoppingbag').css("opacity", "0.5");
  });

  
  
  // empty cart if toatl price is zero
  if ($('#your-shopping-cart').length) {
    Shopify.getCart(function(cartData){
      const total = cartData.total_price;
      if (!total && cartData.items.length> 0) {
        Shopify.clearCart();
      }
    });
  }
});



$( document ).ready(function() {

    var sections = new slate.Sections();
    sections.register('product', theme.Product);

    // Common a11y fixes
    slate.a11y.pageLinkFocus($(window.location.hash));

    $('.in-page-link').on('click', function(evt) {
      slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
    });

    // Target tables to make them scrollable
    var tableSelectors = '.rte table';

    slate.rte.wrapTable({
      $tables: $(tableSelectors),
      tableWrapperClass: 'u-table-wrapper',
    });

    // Target iframes to make them responsive
    var iframeSelectors =
      'iframe[src*="youtube.com/embed"],' +
      'iframe[src*="player.vimeo"]';

    slate.rte.wrapIframe({
      $iframes: $(iframeSelectors),
      iframeWrapperClass: 'u-video-container'
    });

    // Apply a specific class to the html element for browser support of cookies
    if (!slate.cart.cookiesEnabled()) {
      document.documentElement.className = document.documentElement.className.replace('supports-cookies', 'supports-no-cookies');
    }
  
    // variant select event in product listing 
    $('.variantOpt').on('click change', function(e) {
      const pid = $(e.currentTarget).data('pid');
    
      const priceId = document.getElementById('price-' + pid);
      const titleId = document.getElementById('title-' + pid);
    
      const price = $(e.currentTarget).find(':selected').data('price');
      const title = $(e.currentTarget).find(':selected').data('title');
    
      $(priceId).html(price);
      $(titleId).html(title);
    });
 
});


// GWP functions
Shopify.moveAlong = function (updateCart) {
    // If we still have requests in the queue, let's process the next one.
    if (Shopify.queue.length) {
        var request = Shopify.queue.shift();
        // pass the properties into addItem as well
      Shopify.addItem(request.variantId, request.quantity, request.properties, function() {
        return Shopify.moveAlong(updateCart);
      });
    } else if (updateCart) {
        updateCart();
    // If the queue is empty, we will redirect to the cart page.
    } else {
        document.location.href = '/checkout';
    }
};

// Create a new Shopify.addItem function that takes the 'properties' parameter
Shopify.addItem = function (id, qty, properties, callback) {
    var params = {
        quantity: qty,
        id: id
    };
    if (properties != false) {
        params.properties = properties;
    }
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: params,
        success: function (result) {
            if (typeof callback === 'function') {
                callback();
            }
        },
        error: function (result) {
          var data = JSON.parse(result.responseText);
          $('#cart-message').addClass('error').html('<span>' + data.description + '</span>');
          showCart();
        }
    });
}

// ---------------------------------------------------------
// POST to cart/change.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.removeItem = function(variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity=0&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/clear.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.clearCart = function(callback) {
  var params = {
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
  };
  jQuery.ajax(params);
};

// ---------------------------------------------------------
// Error Handling
// ---------------------------------------------------------
Shopify.onError = function(XMLHttpRequest, textStatus) {
  console.error(XMLHttpRequest, textStatus);
}

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// To clear a particular attribute, set its value to an empty string.
// Receives attributes as a hash or array. Look at comments below.
// ---------------------------------------------------------
Shopify.updateCartAttributes = function(attributes, callback) {
  var data = '';
  // If attributes is an array of the form:
  // [ { key: 'my key', value: 'my value' }, ... ]
  if (jQuery.isArray(attributes)) {
    jQuery.each(attributes, function(indexInArray, valueOfElement) {
      var key = attributeToString(valueOfElement.key);
      if (key !== '') {
        data += 'attributes[' + key + ']=' + attributeToString(valueOfElement.value) + '&';
      }
    });
  }
  // If attributes is a hash of the form:
  // { 'my key' : 'my value', ... }
  else if ((typeof attributes === 'object') && attributes !== null) {
    jQuery.each(attributes, function(key, value) {
        data += 'attributes[' + attributeToString(key) + ']=' + attributeToString(value) + '&';
    });
  }
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

// ---------------------------------------------------------
// GET cart.js returns the cart in JSON.
// ---------------------------------------------------------
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    }
  });
};

/* Used by Tools */

function floatToString(numeric, decimals) {
  var amount = numeric.toFixed(decimals).toString();
  if(amount.match(/^\.\d+/)) {return "0"+amount; }
  else { return amount; }
}

/* Used by API */

function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    // Converts to a string.
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  // Removing leading and trailing whitespace.
  return jQuery.trim(attribute);
}